export const EVENT_STATES = {
  SAVED: 'saved',
  NEW: 'new',
  MODIFIED: 'modified',
} as const;

/**
 * Days considered invalid for calendar start dates
 * Uses moment.weekday() values: 0=Sunday, 1=Monday, ..., 5=Friday, 6=Saturday
 */
export const WEEKEND_DAYS = new Set([5, 6]); // Friday, Saturday

export const TIME_FORMATS = {
  MONTH_DAY: 'MMMM D',
  MONTH_ABBR_DAY: 'ddd M/DD',
  HOUR_MINS: 'h:mm',
} as const;

/**
 * Minimum lead time (minutes) used when rescheduling an interview. Read in two
 * places that must agree:
 * - `setEventError` past-start validation in calendar-events-util
 * - `slotPropGetter` past-overlay boundary in useCalendarEventStyling
 * Together they ensure the gray slot overlay ends exactly where dragging
 * the editable event becomes valid.
 */
export const EDIT_MODE_LEAD_TIME_MINUTES = 5;
